import axios from "axios";
import { endpoints } from "../_config";

class AuthService {
  /**
   * Signup Api
   * @param {*} fullname, email, password properties
   * @returns accessToken
   */
  static async signup(email, password, fullName) {
    return axios
      .post(endpoints.auth.signup, { email, password, fullName })
      .then((response) => response.data);
  }

  /**
   * Login Api
   * @param {*} email, password properties
   * @returns accessToken
   */
  static async signin(email, password) {
    return axios
      .post(endpoints.auth.signin, {
        email,
        password,
      })
      .then((response) => response.data);
  }

  /**
   * Forgot Api
   * @param {*} email
   */
  static async forgot(email) {
    return axios
      .post(endpoints.auth.forgot, {
        email,
      })
      .then((response) => response.data);
  }

  /**
   * Reset Password Api
   * @param {*} password
   * @param {*} confirm password
   */
  static async resetPassword(data, token) {
    return axios
      .post(endpoints.auth.resetPassword(token), data)
      .then((response) => response.data);
  }
}

export { AuthService };
